// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const zh_cn_pmainpkglink3 = /** @type {(inputs: {}) => string} */ () => {
	return `包源码`
};

const en_pmainpkglink3 = /** @type {(inputs: {}) => string} */ () => {
	return `Package`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "zh-cn" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const pmainpkglink3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pmainpkglink3(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("pmainpkglink3", locale)
	if (locale === "zh-cn") return zh_cn_pmainpkglink3(inputs)
	if (locale === "en") return en_pmainpkglink3(inputs)
	return "pMainPkgLink"
};
export { pmainpkglink3 as "pMainPkgLink" }